import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

export default function Messages() {
  return (
    <div>
      <h1 className="text-3xl font-extrabold text-gray-900">Messages</h1>
      <p className="text-gray-600 mt-1 mb-6">Live module preview</p>

      <div className="bg-gray-50 border border-gray-100 rounded-2xl px-6 py-16 flex flex-col items-center text-center">
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center mb-6">
          <Sparkles className="w-6 h-6 text-white" />
        </div>

        <h2 className="text-2xl font-extrabold text-gray-900 mb-4">Messages</h2>

        <p className="text-gray-500 max-w-xl mb-8">
          This module is part of the ProtoHub MVP scaffold — data schema,
          workflows and role permissions are wired. Full UI is being rolled
          out module-by-module across the next releases.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/app/dashboard"
            className="bg-white border border-gray-200 text-gray-900 font-semibold text-sm px-5 py-2.5 rounded-xl hover:bg-gray-100 transition"
          >
            Innovator Home
          </Link>
          
           <a href="#apic-admin"
            className="flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold text-sm px-5 py-2.5 rounded-xl hover:opacity-90 transition"
          >
            APIC Admin
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  );
}